import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { requestGetCategoryRankProducts } from '@apis/renewal/event';
import { ICategoryProdct } from '@wconcept/wconcept-common/models/event/custom';
import { useWckQuery } from '@hooks/wckQuery/useWckQuery';

interface UseCategoryRankProductsParams {
  categoryKey: string;
  enabled?: boolean;
}

interface UseCategoryRankProductsResult {
  data: {
    data: ICategoryProdct[];
    baseData: {
      updateTime: string;
    };
  };
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

export const useCategoryRankProducts = ({
  categoryKey,
  enabled = true,
}: UseCategoryRankProductsParams): UseCategoryRankProductsResult => {
  const { data, isLoading, isError, error, refetch } = useWckQuery({
    queryKey: ['categoryRankProducts', categoryKey],
    queryFn: () => requestGetCategoryRankProducts(categoryKey),
    enabled: enabled && !!categoryKey,
    staleTime: 60 * 1000 * 5, // 5분
    gcTime: 60 * 1000 * 10, // 10분
    retry: 1,
    placeholderData: keepPreviousData,
  });
  return {
    data: data || {
      data: [],
      baseData: {
        updateTime: '',
      },
    },
    isLoading,
    isError,
    error: error || null,
    refetch,
  };
};
